import { availabilityTypeAvailable, availabilityTypeNotAvailable, availabilityTypeOnlyCalendarAccess } from '@vooban/tc3-core/laborAvailability';

const AvailabilityTypeEnum = {
  Available: availabilityTypeAvailable,
  NotAvailable: availabilityTypeNotAvailable,
  OnlyCalendarAccess: availabilityTypeOnlyCalendarAccess,
};

export default AvailabilityTypeEnum;
